import SectionTitle from "../layout/SectionTitle";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useTranslation } from 'react-i18next';
// Image component

export default function NotreEngagement() {
  const { t } = useTranslation();
  const [sectionRef, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  return (
    <section className="py-8 bg-white" ref={sectionRef} id="notre-engagement">
      <div className="container mx-auto px-4">
        <SectionTitle
          overline={t('home.whoareus.title')}
          highlight={t('home.whoareus.highlight')}
          showLogo={true}
          align="left"
        />
        
        {/* Structure en colonne sur mobile (image au-dessus, texte en-dessous) et en ligne sur desktop */}
        <div className="flex flex-col lg:flex-row items-stretch gap-6 md:gap-8 mt-8">
          {/* Image en premier (en haut en mobile, à gauche en desktop) */}
          <motion.div 
            className="w-full lg:w-1/3 relative order-1 lg:order-1 h-auto flex"
            initial={{ opacity: 0, x: -30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            <div className="w-full h-full rounded-lg overflow-hidden shadow-xl">
              <img
                src="images/who_us.jpg"
                alt="SOCABEG"
                className="w-full h-full object-cover"
                style={{
                  height: '100%',
                  minHeight: '410px',
                  objectPosition: 'center'
                }}
                loading="lazy"
              />
            </div>
          </motion.div>
          
          {/* Contenu après l'image (en bas en mobile, à droite en desktop) */}
          <motion.div 
            className="lg:w-2/3 order-2 lg:order-2 mt-5 lg:mt-0"
            initial={{ opacity: 0, x: 30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            <motion.p 
              className="text-base sm:text-lg md:text-xl text-socabeg-dark-gray mb-4 sm:mb-6 md:mb-8 font-medium italic text-justify"
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: 0.3, duration: 0.6 }}
            >
              {t('home.whoareus.description')}
            </motion.p>
            
            <motion.div 
              className="space-y-4 text-socabeg-dark-gray"
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: 0.4, duration: 0.6 }}
            >
              <motion.p 
                className="text-base sm:text-lg text-gray-700 leading-relaxed mb-3 sm:mb-4 text-justify"
                dangerouslySetInnerHTML={{ __html: t('home.whoareus.engagement1') }}
              />
              <motion.p 
                className="text-base sm:text-lg text-gray-700 leading-relaxed mb-3 sm:mb-4 text-justify"
                dangerouslySetInnerHTML={{ __html: t('home.whoareus.engagement2') }}
              />
              <motion.p 
                className="text-base sm:text-lg text-gray-700 leading-relaxed mb-3 sm:mb-4 text-justify"
                dangerouslySetInnerHTML={{ __html: t('home.whoareus.engagement3') }}
              />
              <motion.p 
                className="text-base sm:text-lg text-gray-700 leading-relaxed mb-3 sm:mb-4 text-justify"
                dangerouslySetInnerHTML={{ __html: t('home.whoareus.engagement4') }}
              />
              <motion.p 
                className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6 text-justify"
                dangerouslySetInnerHTML={{ __html: t('home.whoareus.engagement5') }}
              />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}